import React, { useState } from 'react';

import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import moment from 'moment';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { CancelButton } from 'components/common/Button';
import { MaskedDots } from 'components/common/icons';
import { unImpersonate } from 'lib/auth';
import axios from 'lib/axios.factory';

import { BaseBanner } from './common';

const Container = styled(BaseBanner).withConfig({
  displayName: 'ContainerImpersonated ',
})`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 20px;
  font-weight: 400;
  color: red;
  background: pink;
`;

const DetailsWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 8px;
`;

const ShowDetailsToggle = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  color: inherit;
  opacity: 0.7;
  &:hover {
    opacity: 1;
  }
`;

export const Impersonated = () => {
  const user = useSelector((state) => state.user.user);
  const [isVisible, setIsVisible] = useState(true);

  return (
    <Container>
      {moment().format('DD/MM')} WARNING You are impersonating:
      <DetailsWrapper>
        {isVisible ? <span>{user.fullname}</span> : <MaskedDots fill="#cc0000" count={10} />}
        {isVisible ? (
          <span>({user.email})</span>
        ) : (
          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
            (<MaskedDots fill="#cc0000" count={16} />)
          </span>
        )}
        <Tooltip title={isVisible ? 'Hide name and email' : 'Show name and email'}>
          <ShowDetailsToggle
            onClick={() => {
              setIsVisible((v) => !v);
            }}
            aria-label={isVisible ? 'Hide name and email' : 'Show name and email'}
          >
            {isVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
          </ShowDetailsToggle>
        </Tooltip>
      </DetailsWrapper>
      <CancelButton
        handleClick={() => {
          unImpersonate(localStorage, axios).then(() => {
            window.location = '/';
          });
        }}
      >
        Back to yourself
      </CancelButton>
    </Container>
  );
};
